import { graphql } from 'gatsby';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Container } from '../Container';
import { Section } from '../Section';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';
import { SimplePageHeaderFragment } from '../../types/graphqlTypes';
import { Divider } from '../Divider';
import { Button } from '../Button';
import { useNavigation } from '../../context/NavigationContext';
import { createMarkup } from '../../utils';

interface SimplePageHeaderProps extends SimplePageHeaderFragment {
  meta?: string;
  tight?: boolean;
  hasDivider?: boolean;
}

const StyledHeader = styled(Spacer)`
  h1 {
    max-width: 896px;
  }

  p {
    max-width: 860px;
  }
`;

const StyledBackButton = styled.div`
  ${({ theme: { space } }) => css`
    margin-bottom: ${space.lg};
    display: inline-flex;
  `};
`;

export const SimplePageHeader: FC<Omit<SimplePageHeaderProps, '__typename'>> = ({
  title,
  lead,
  meta,
  tight,
  hasDivider,
  ...rest
}) => {
  const { location } = useNavigation();

  return (
    <>
      <Section {...rest} contained tight={tight}>
        {location?.state?.fromSearchResults && (
          <StyledBackButton>
            <Button variant="pill" arrowLeft onClick={() => window.history.back()}>
              Back to search results
            </Button>
          </StyledBackButton>
        )}

        <StyledHeader spacing="half">
          <Typography component="h1" variant="displaySmall">
            {title}
          </Typography>
          {lead && (
            <Typography component="p" variant="lead">
              {createMarkup(lead)}
            </Typography>
          )}
          {meta && (
            <Typography component="p" variant="bodyLarge">
              {meta}
            </Typography>
          )}
        </StyledHeader>
      </Section>
    </>
  );
};

export const SimplePageHeaderQuery = graphql`
  fragment SimplePageHeader on KFH_UmbracoBasePageHeaderType {
    title
    lead
  }
`;
